module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"AWSCognito","commonjs2":"aws-sdk","commonjs":"aws-sdk","amd":"aws-sdk"}
 ** module id = 10
 ** module chunks = 0
 **/